import theme from 'src/theme'
import styled from 'styled-components'

interface WrapperContainerProps {
  isEmpty: boolean
}
export const WrapperContainer = styled.div<WrapperContainerProps>`
  background: ${theme.colors.gray2};
  border-radius: 2px;
  padding: 16px;

  .slateEditor {
    background-color: ${theme.colors.gray1};
    min-height: 98px !important;
    padding: 4px 11px;
    border: 1px solid ${theme.colors.gray5};
    border-radius: 2px;

    ${(props) =>
      props.isEmpty
        ? "font-family: 'Segoe UI';" +
          'font-style: normal;' +
          'font-weight: ' +
          theme.fontWeights.normal +
          ';' +
          'font-size: ' +
          theme.fontSizes.medium +
          ';' +
          'color: ' +
          theme.colors.gray7 +
          ';'
        : ''}

    &:hover,
    &:focus,
    &:active {
      border: 1px solid ${theme.colors.brandPrimary6};
      border-inline-end-width: 1px;
      outline: none;
    }
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 11px;
`

export const TitleWrapper = styled.div`
  display: flex;
  gap: 6px;
  font-weight: ${theme.fontWeights.semiBold};
  font-size: ${theme.fontSizes.medium};
  color: ${theme.colors.black};
`
